import { useNavigate, useLocation } from "react-router-dom";
import { useSession } from "Contexts/SessionContext";

const useSessionNavigate = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { sessionCode } = useSession();

  const buildPathWithSession = (to, code = sessionCode) => {
    if (!code) return to;

    if (typeof to === "string") {
      const [pathname, existingSearch] = to.split("?");
      const params = new URLSearchParams(existingSearch || "");
      params.set("session", code);
      return `${pathname}?${params.toString()}`;
    }

    if (typeof to === "object") {
      const params = new URLSearchParams(to.search || "");
      params.set("session", code);
      return {
        ...to,
        search: params.toString(),
      };
    }

    return to;
  };

  const sessionNavigate = (to, options) => {
    const pathWithSession = buildPathWithSession(to);
    navigate(pathWithSession, options);
  };

  const getCurrentPathWithSession = (code = sessionCode) => {
    if (!code) return location.pathname + location.search;
    const params = new URLSearchParams(location.search);
    params.set("session", code);
    return `${location.pathname}?${params.toString()}`;
  };

  const updateSessionInUrl = (code) => {
    if (!code) return;
    const newPath = getCurrentPathWithSession(code);
    navigate(newPath, { replace: true });
  };

  return {
    sessionNavigate,
    buildPathWithSession,
    updateSessionInUrl,
    getCurrentPathWithSession,
  };
};

export default useSessionNavigate;
